<template>
<el-dialog class="add-exchange-popup" title="新增" :visible="showDialog" @close="onClose()" width="800">
   <div class="same" v-if="step == 1">
       <el-form :model="form" label-position="left" label-width="100px">
        <el-form-item label="物品類型">
            <el-radio-group v-model="form.category">
                <el-radio v-for="(category,i) in categories" :label="category"  :value="category" :key="i"></el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="組合" v-if="form.category === '專卡'">
            <el-select v-model="form.groupName" placeholder="请選擇組合">
                <el-option v-for="(member,i) in groups" :label="member"  :value="member" :key="i"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="專輯名稱" v-if="form.category === '專卡'">
            <el-select v-model="form.album" placeholder="请選擇專輯" >
                <el-option v-for="(album,i) in albums" :label="album"  :value="album" :key="i"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="描述">
            <el-input autosize maxlength="100" type="textarea" v-model="form.desc" placeholder="描述" ></el-input>
        </el-form-item> 
        <!-- <el-form-item label="上傳圖片">
               <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-success="handleAvatarSuccess"
  :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
        </el-form-item>  -->
        <el-form-item label="擁有成員">
            <el-select v-model="form.ownMember" multiple placeholder="请選擇成員" >
                <el-option v-for="(member) in members" :label="member"  :value="member" :key="member.eng"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="欲交換成員">
            <el-select v-model="form.targetMember" multiple placeholder="请選擇成員" >
                <el-option v-for="(member) in members" :label="member"  :value="member" :key="member.eng"></el-option>
            </el-select>
        </el-form-item>
       <el-form-item label="備註">
            <el-checkbox-group v-model="form.note">
                <el-checkbox v-for="(note,i) in noteList" :label="note"  :key="i"  name="note"></el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="交易方式">
            <el-checkbox-group v-model="form.exchangeWay">
                <el-checkbox v-for="(way,i) in ways" :label="way"  :key="i"  name="way"></el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        </el-form>
    </div>   
    <div v-if="step == 2" class="check-info">
        <p>
          <span class="form-title">交換物品</span>  
          <span class="category">{{form.category}}</span>
          <span class="album" v-if="form.category === '專卡'">{{form.groupName}} {{form.album}}</span>
        </p>
        <p><span class="form-title">擁有成員</span><span class="member" v-for="(member) in form.ownMember" :key="member">{{member}}</span></p>
        <p><span class="form-title">欲交換成員</span><span  v-for="(member) in form.targetMember" :key="member">{{member}}</span></p>
        <p><span class="form-title">可交易方式</span><span v-for="(way) in form.exchangeWay" :key="way">{{way}}</span></p>
        <p><span class="form-title">備註</span><span v-for="(note) in form.note" :key="note">#{{note}} </span></p>
        <p><span class="form-title">描述</span></p>
        <div class="desc">{{form.desc}}</div>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="onClose()">{{step == 1?"取消":"上一步"}}</el-button>
        <el-button type="primary" @click="onSubmit()">{{step == 1?"下一步":"確認送出"}}</el-button>
    </div>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { createExchangeItem } from '../../../api/exchange'; 

export default {
    props: {
        showDialog: {
            type: Boolean,
            require: true
        }
    },
    data(){
        return {
            imageUrl: '',
            dialogImageUrl: '',
        dialogVisible: false,
            step: 1,
            exchangeType: '',
            uploadData: null,
            form: {
                groupName: '',
                album: '',
                category: '',
                desc:'',
                exchangeWay: [],
                note:[],
                // img: '',
                ownMember:[],
                targetMember: [],
                
            },
            members:[],
            albums:[],
            categories:['專卡','玩偶/娃娃','官方周邊','飯制周邊'],
            ways: ['店到店','賣貨便','面交','郵寄','其他'],
            noteList: ['不拍對光','面交優先','無損換無損','不跨版'],
        }
    },
    mounted(){
        this.members = this.$store.state.basic.nctMembers
    },
    computed:{
        ...mapState({
            groups: state => state.basic.groups,
            nctMembers: state => state.basic.nctMembers,
            nct127Members: state => state.basic.nct127Members,
            nctdreamMembers: state => state.basic.nctdreamMembers,
            wayvMembers: state => state.basic.wayvMembers,
            nctAlbums: state => state.basic.nctAlbums,
            nct127Albums: state => state.basic.nct127Albums,
            nctdreamAlbums: state => state.basic.nctdreamAlbums,
            wayvAlbums: state => state.basic.wayvAlbums,
        }),

    },
    watch:{
        'form.groupName':{
            handler(newValue){
                switch(newValue){
                case 'NCT':
                    this.members = this.nctMembers
                    this.albums = this.nctAlbums
                    break;
                case 'NCT127':
                    this.members = this.nct127Members
                    this.albums = this.nct127Albums
                    break;
                case 'NCT Dream':
                    this.members = this.nctdreamMembers
                    this.albums = this.nctdreamAlbums
                    break;
                case 'WayV':
                    this.members = this.wayvMembers
                    this.albums = this.wayvAlbums
                    break;
                default:
                    this.members = this.nctMembers
                    this.albums = this.nctAlbums
            }
            }
        },
        'form.category':{
            handler(newValue){
                if(newValue){
                    this.form.groupName = ''
                    this.form.ownMember = []
                    this.form.targetMember = []
                }
            }
        },
        showDialog(newValue){
            if (newValue){
                this.initForm()
            }
        }
    },
    methods:{
        initForm(){
            this.form = {
                groupName: '',
                album: '',
                category: '',
                desc:'',
                exchangeWay: [],
                note:[],
                ownMember:[],
                targetMember: [],
                
            }
        },
        onClose(){
            if (this.step == 2){
                this.step = 1
                return
            }
            this.$store.commit('user/hideAddExchange')
        },
        onBeforeUpload(file){
            console.log(file)
        },
        handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
        handleAvatarSuccess(res, file) {
        console.log(res)
        console.log(file.raw)
        var reader = new FileReader();

        reader.onload = function () {
            console.log(reader.result);
        }

        reader.readAsBinaryString();
        this.imageUrl = URL.createObjectURL(file.raw);
        this.form.img = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
        onSubmit(){
            this.submitItem()
             
            
            
        },
        submitItem(){
            this.form.creator = this.$store.state.user.userName
            let params = this.form
            if (this.step == 1){
                this.step = 2
                return 
            } 
            
            createExchangeItem(params).then(res => {
                if (res.status == 'success') {
                    this.$message.success('成功新增交換物品')
                    this.$store.commit('user/hideAddExchange')
                    if (this.$route.path == '/exchange'){
                        this.$router.push('/reload')
                    } else {
                        this.$router.push('/exchange')
                    }
            
                }
                }).catch(err => {
                    console.log(err);
                });
        },
        addItem() {
            this.form.itemList.push({
                img: '',
                ownMember:[],
                targetMember: [], 
                key:Date.now()
            });
            console.log(this.form)
        }
    }


}
</script>

<style lang="scss" scoped>
.add-exchange-popup {
    /deep/.el-form-item__label{
        background-color: $mainColor;
         text-align: center;
            border-radius: 5px;
            margin-right: 10px;
            padding: 0;
    }
    /deep/ .el-textarea {
        width: 90%;
    }
    .check-info {
        p {
            margin-bottom: 10px;
        }
        .form-title {
            display: inline-block;
            background-color: $mainColor;
            width: 90px;
            padding: 10px 5px;
            text-align: center;
            border-radius: 5px;
            margin-right: 10px;
        }
        .desc {
            border-radius: 10px;
            border: 1px solid $textColor;
            padding: 20px;
        }
    }
}

</style> 